var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import APButton from '../APButton';
import APIcon from '../APIcon';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import history from '../../../helpers/history';
import './Modal.css';
var baseClass = 'ap-modal';
var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);
  function Modal(props) {
    _classCallCheck(this, Modal);
    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));
    _this.getBEMClasses = function () {
      return getBEMClasses(baseClass, _this.props.customClass);
    };
    _this.renderCloseIcon = function () {
      var bemClasses = _this.getBEMClasses();
      var onClick = _this.props.onCancel || _this.props.close;
      return React.createElement('div', {
        onClick: onClick,
        className: bemClasses('close-icon')
      }, React.createElement(APIcon, {
        name: 'close',
        classModifiers: 'big'
      }));
    };
    _this.handleFooterButtonClick = function (e) {
      _this.props.footer.onClick();
      !_this.props.footer.overrideClose && _this.props.close();
    };
    _this.modalRef = null;
    _this.unlisten = null;
    return _this;
  }
  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;
      ReactModal.setAppElement(this.modalRef);
      this.unlisten = history.listen(function (location, action) {
        var close = _this2.props.onCancel || _this2.props.close;
        if (action === 'POP' && _this2.props.isOpen) {
          close();
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unlisten();
      this.unlisten = null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;
      if (!this.props.isOpen) return null;
      var bemClasses = this.getBEMClasses();
      return React.createElement('div', {
        ref: function ref(_ref) {
          return _this3.modalRef = _ref;
        }
      }, React.createElement(ReactModal, {
        className: bemClasses(),
        ariaHideApp: false,
        overlayClassName: bemClasses('overlay'),
        onRequestClose: this.props.onCancel || this.props.close,
        isOpen: this.props.isOpen
      }, React.createElement('div', {
        className: bemClasses('header')
      }, this.props.title), this.renderCloseIcon(), React.createElement('div', {
        className: bemClasses('content')
      }, this.props.children), this.props.footer && React.createElement('div', {
        className: bemClasses('footer')
      }, React.createElement(APButton, {
        customClass: bemClasses(),
        onClick: this.handleFooterButtonClick,
        styleName: this.props.footer.buttonStyle,
        disabled: this.props.footer.disabled
      }, this.props.footer.buttonText))));
    }
  }]);
  return Modal;
}(React.Component);
Modal.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]),
  onCancel: PropTypes.func,
  close: PropTypes.func.isRequired,
  overrideClose: PropTypes.bool,
  customClass: PropTypes.string
};
Modal.defaultProps = {
  overrideClose: false
};
export default Modal;